var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-title-sub-s align-middle content-center"},[_c('p',{staticClass:"text-chplus-regular text-landingfade-dark"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }